const WARMED_ASSETS=new Set<string>()
const WARMING_ASSETS=new Map<string,Promise<void>>()

export function isAssetWarm(url:string){
  return WARMED_ASSETS.has(url)
}

export function warmCachedAsset(url:string,timeoutMs=45_000){
  if(WARMED_ASSETS.has(url))return Promise.resolve()
  const current=WARMING_ASSETS.get(url)
  if(current)return current

  const controller=new AbortController()
  const timer=globalThis.setTimeout(()=>controller.abort(),timeoutMs)
  const task=fetch(url,{method:'GET',cache:'force-cache',signal:controller.signal})
    .then(async response=>{
      if(!response.ok)throw new Error(`${response.status} ${response.statusText}`)
      if(response.body){
        const reader=response.body.getReader()
        for(;;){
          const {done}=await reader.read()
          if(done)break
        }
      }else{
        await response.arrayBuffer()
      }
      WARMED_ASSETS.add(url)
    })
    .finally(()=>{
      globalThis.clearTimeout(timer)
      WARMING_ASSETS.delete(url)
    })

  WARMING_ASSETS.set(url,task)
  return task
}
